<template>
  <v-container>
    <kim-background v-if="$route.name !== 'mixed'"/>

    <v-btn text class="mb-5 primary--text" :to="{name:'observation'}">
      <v-icon>mdi-arrow-left</v-icon>
      <span>{{$i18n.t('AssessmentPage.backLink')}}</span>
    </v-btn>

    <div class="headline">{{$i18n.t('AssessmentPage.title')}}</div>
    <div class="subtitle-1">{{currentExercise.name}} {{$i18n.t('AssessmentPage.with')}} {{currentParticipant.firstName}} {{currentParticipant.lastName}}</div>
    <!--   Todo Check if CurrentExercise.Competencies are generated correctly -> competencies seem to be included multiple times which should not be the case -->
    <v-row align="center" class="mt-5" v-for="competency in currentExercise.competencies" :key="competency.id">
      <v-col cols="12">
        <assessment-competency-card
          :scale-criterions="runInfo.scale"
          :competency='competency'
          :matrix='currentMatrix.find((cm) => cm.competencyId === competency.id)'
          @saveWithDelay='(payload) => $emit("saveWithDelay", payload)'
        />
      </v-col>
    </v-row>

    <v-btn v-if='$route.name !== "mixed"' text class="mt-5 primary--text" :to="{name:'observation'}">
      <v-icon>mdi-arrow-left</v-icon>
      <span>{{$i18n.t('AssessmentPage.backLink')}}</span>
    </v-btn>

  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import KimBackground from './KimBackground.vue';
import AssessmentCompetencyCard from './AssessmentCompetencyCard.vue';

export default {
  name: 'Assessment',
  components: {
    AssessmentCompetencyCard,
    KimBackground,
  },
  props: ['currentExercise', 'currentParticipant', 'currentMatrix'],
  computed: {
    ...mapGetters(['currentObserver']),
    ...mapState({
      runInfo: (state) => state.runInfo,
      user: (state) => state.user,
    })
  },
};
</script>

<style type="text/css">
  .v-input__slot {
    align-items: center!important;
    justify-content: center!important;
  }
</style>
